module.exports = __webpack_public_path__ + "static/img/h5-2.659f314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h5-2.png
// module id = hkSK
// module chunks = 1